var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Card } from '@material-ui/core';
/**
 * No actual changes from Card here at the moment, just created in case we do need styling changes.
 */
const AdeptCard = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return React.createElement(Card, Object.assign({}, otherProps), children);
};
export default AdeptCard;
//# sourceMappingURL=AdeptCard.js.map